import { Priority } from '@/portfolio/proposal-builder/types'

/** The floors' tier when a sleeve never set one; matches the backend default. */
export const DEFAULT_CASHFLOW_TARGET_PRIORITY = Priority.Medium

export function parsePriority(
  value: number | null | undefined,
): Priority | undefined {
  switch (value) {
    case Priority.Low:
      return Priority.Low
    case Priority.Medium:
      return Priority.Medium
    case Priority.High:
      return Priority.High
    case Priority.Unrelaxable:
      return Priority.Unrelaxable
    default:
      return undefined
  }
}
